import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import Logout from 'components/Logout';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Sidebar from 'components/Sidebar';
import Welcome from 'components/Welcome';
import Message from 'components/Message';
import { useScrollToTop } from 'hooks'

const Layout = ({ children }) => {
    const sidebar = useSelector((state) => state.sidebar);
    const { logout } = useSelector((state) => state.sign);
    const sidebarClasses = cx('sidebar__col', {
        'sidebar__col--open': sidebar.open,
    });

    useScrollToTop();
    return (
        <Fragment>
            <Container fluid className="p-0">
                <Header />
            </Container>
            <Container className="p-0 container-main container__app">
                {!isMobileOnly && <Welcome />}
                {!isMobileOnly && <Message position="top" />}

                <Container className="pt-2">
                    <Row className="ml-0 mr-0">
                        <Col className={sidebarClasses}>
                            <div className="sidebar__sticky">
                                {isMobileOnly && <Welcome />}
                                <Sidebar />
                            </div>
                        </Col>
                        <Col className="pl-25px col__page">{children}</Col>
                    </Row>
                </Container>
            </Container>
            <Container fluid className="p-0">
                <Footer />
            </Container>
            {logout && <Logout />}
        </Fragment>
    );
};

Layout.propTypes = {
    children: PropTypes.any,
};

export default Layout;
